// Списъкът с езици на едно място — нов език = нов ред тук (+ преводите му).
export const LANGUAGES = [
  { key: "bg", flag: "🇧🇬", label: "Български" },
  { key: "en", flag: "🇬🇧", label: "English" },
];
